import { createContext } from 'react';
import { CUSTOMER_NAME_COL, CUSTOMER_KAM_EMP_NAME_COL, CUSTOMER_ECO_EMP_NAME_COL, CUSTOMER_LATEST_INVOICE_MONTH_COL, CUSTOMER_LATEST_INVOICE_AMOUNT_COL } from '../i18n/keyConstants';

const selectedFilters = {
    name: '',
    kamEmpName: '',
    ecoEmpName: '',
    latestInvoiceMonth: '',
    latestInvoiceAmount: '',
};

const tableColumnExtensions = [
    { columnName: 'name', width: 280, align: 'left' },
    { columnName: 'kamEmpName', width: 280, align: 'left' },
    { columnName: 'ecoEmpName', width: 280, align: 'left' },
    { columnName: 'latestInvoiceMonth', width: 280, align: 'left' },
    { columnName: 'latestInvoiceAmount', width: 280, align: 'left' },
];

export const initialState = {
    customers: [],
    filters: [],
    requestUri: null,
    defaultFilters: [],
    hiddenColumns: [],
    showCustomCols: false,
    columnName: 'name',
    tableSize: 0,
    direction: 'asc',
    pageSize: 25,
    currentPage: 1,
    sortInfo: {},
    isLoading: true,
    error: null,
    columns: [
        { title: CUSTOMER_NAME_COL, name: 'name' },
        { title: CUSTOMER_KAM_EMP_NAME_COL, name: 'kamEmpName' },
        { title: CUSTOMER_ECO_EMP_NAME_COL, name: 'ecoEmpName' },
        { title: CUSTOMER_LATEST_INVOICE_MONTH_COL, name: 'latestInvoiceMonth' },
        { title: CUSTOMER_LATEST_INVOICE_AMOUNT_COL, name: 'latestInvoiceAmount' },
    ],
    selectedFilters: selectedFilters,
    isResettingFilters: false,
    tableColumnExtensions,
    defaultTableColumnExtensions: tableColumnExtensions,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state,
                customers: action.customers,
                tableSize: action.totalRows,
                isLoading: false,
            };
        case 'FETCH_ERROR':
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case 'SET_ISLOADING_TRUE':
            return {
                ...state,
                isLoading: true,
            };
        case 'SET_ISLOADING_FALSE':
            return {
                ...state,
                isLoading: false,
            };
        case 'FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
            };
        case 'SET_REQUEST_URI':
            return {
                ...state,
                requestUri: action.payload,
            };
        case 'RESET_FILTERS':
            return {
                ...state,
                filters: [],
                defaultFilters: [],
                currentPage: 1,
                isResettingFilters: true,
            };
        case 'FILTERS_RESET':
            return {
                ...state,
                isResettingFilters: false,
            };
        case 'PAGESIZE':
            return {
                ...state,
                pageSize: action.payload,
            };
        case 'HIDDEN_COLUMNS':
            return {
                ...state,
                hiddenColumns: action.payload,
            };
        case 'SHOW_CUSTOM_COLS':
            return {
                ...state,
                showCustomCols: action.payload,
            };
        case 'HIDDEN_COLUMNS_AND_CUSTOM_COLS':
            return {
                ...state,
                hiddenColumns: action.hiddenColumns,
                showCustomCols: action.showCustomCols,
            };
        case 'CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload,
            };
        case 'SORT_INFO':
            return {
                ...state,
                sortInfo: action.sortInfo,
                columnName: action.columnName,
                direction: action.direction,
            };
        case 'SELECTED_FILTERS':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
            };
        case 'SELECTED_FILTERS_AND_FILTERS_RESET':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
                isResettingFilters: false,
            };
        case 'FILTERS_AND_SELECTED_FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.columnNameVal }),
            };
        case 'DESKTOP_COLUMN_WIDTHS':
            return {
                ...state,
                tableColumnExtensions,
            };
        case 'MOBILE_COLUMN_WIDTHS':
            return {
                ...state,
                tableColumnExtensions: tableColumnExtensions.map((c) => c.width === 'auto'),
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
